import React from "react";
import MainInformation from "./MainInformation";
import BalanceSheetAssets from "./BalanceSheetAssets";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import _ from "lodash";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import Button from "../../../toolkit/Button";
import { Box, Grid, Stack } from "@mui/material";
import CircledNumber from "../../../components/CircledNumber";
import LiabilitiesandEquity from "./LiabilitiesandEquity";
import IncomeStatement from "./IncomeStatement";
import SelectFinancialData from "./SelectFinancialData";
import axios from "../../../utils/fvAxios";
import { toast } from "react-toastify";

import useFetch from "../../../utils/useFetch";

export default function FinancialDataSubSec({
    Secid,
    selected,
    setNextSection,
    setPrevSection,
    SectionType,
    clicked,
    Pqid,
    handleClose,
    fetchedFinancialDataEntry
}) {
    const params = new URLSearchParams(window.location.search);
    const PQID = params.get("pqid");
    const preq=PQID==null?Pqid:PQID


    function onSave(col, prop, val) {
        console.log(col, prop, val);
    }

    const [FinancialDataEntry, setFinancialDataEntry] = useState([]);
    const [FinancialData, setFinancialData] = useState([]);
    const [FinancialAsset, setFinancialAsset] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const { data: res } = useFetch(
        "Prequalification/GetFinancialDataEntry?pqid=" + preq + "&refresh=" + refresh
    );
    useEffect(() => {
        if (res?.data) {
            setFinancialDataEntry(res?.data?.map((r) => r));
            setFinancialData(res?.data?.map((r) => r));
            fetchedFinancialDataEntry(res?.data?.map((r) => r));
        }
    }, [res]);

    function dataChange(col, prop, val) {
                const data = _.cloneDeep(FinancialDataEntry);

        //let newData;
        // if (_.isObject(val) && !_.isArray(val)) {
        //   // from subFields
        //   newData = { ...data[col], prop: { ...data[col][prop], ...val } };
        // } else {
        //   newData = { ...data[col], prop: val };
        // }

        data[col][prop] = val;

        setFinancialDataEntry(data);
        setFinancialData(data)
    }

      function toNumber(data) {
        if (data == null || data == "") {
          return 0;
        }
        return parseInt(data);
      }



    const Savedata = async () => {
        const details = FinancialData?.flatMap((r) => {
            return {
                sourceOfFinancialStatements: r.sourceOfFinancialStatements,
                id: r?.id,
                vendorId: r?.vendorId,
                dateOfFinancialStatements: r?.dateOfFinancialStatements,
                lastUpdatedOn: r?.lastUpdatedOn,
                lastUpdatedBy: r?.lastUpdatedBy,
                dateofinterimfinancialstatement: r?.dateofinterimfinancialstatement,
                sourceOfFinancialStatements: r?.sourceOfFinancialStatements,
                cashAndCashEquivalents: r?.cashAndCashEquivalents,
                investments: r?.investments,
                receivablesCurrent: r?.receivablesCurrent,
                receivableRetainage: r?.receivableRetainage,
                costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts: r?.costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts,
                refundableIncomeTaxes: r?.refundableIncomeTaxes,
                noteReceivable: r?.noteReceivable,
                otherCurrentAssets: r?.otherCurrentAssets,
                netPropertyAndEquipment: r?.netPropertyAndEquipment,
                otherAssets: r?.otherAssets,
                linesOfCreditShortTermBorrowings: r?.linesOfCreditShortTermBorrowings,
                installmentNotesPayableDueWithinOneYear: r?.installmentNotesPayableDueWithinOneYear,
                accountsPayable: r?.accountsPayable,
                retainagePayable: r?.retainagePayable,
                accruedExpenses: r?.accruedExpenses,
                billingsInExcessOfCostsAndEstimatedEarningsOnUncompletedContracts: r?.billingsInExcessOfCostsAndEstimatedEarningsOnUncompletedContracts,
                currentIncomeTaxesPayable: r?.currentIncomeTaxesPayable,
                deferredIncomeTaxesPayableCurrent: r?.deferredIncomeTaxesPayableCurrent,
                notesPayableDueAfterOneYear: r?.notesPayableDueAfterOneYear,
                equipmentLinesOfCredit: r?.equipmentLinesOfCredit,
                otherLongTermLiabilities: r?.otherLongTermLiabilities,
                deferredIncomeTaxesPayableLongTerm: r?.deferredIncomeTaxesPayableLongTerm,
                totalStockholdersEquity: r?.totalStockholdersEquity,
                constructionRevenues: r?.constructionRevenues,
                constructionDirectCosts: r?.constructionDirectCosts,
                nonConstructionGrossProfitLoss: r?.nonConstructionGrossProfitLoss,
                generalAndAdministrativeExpenses: r?.generalAndAdministrativeExpenses,
                otherIncomeDeductions: r?.otherIncomeDeductions,
                incomeTaxExpenseBenifit: r?.incomeTaxExpenseBenifit,
                depreciationAndAmortization: r?.depreciationAndAmortization,
                interestExpense: r?.interestExpense,
                totalBacklog: r?.totalBacklog,
                totalLineOfCredit: r?.totalLineOfCredit,
                lineOfCreditAvailability: r?.lineOfCreditAvailability,
                totalThreeLargestCompletedProjects: r?.totalThreeLargestCompletedProjects,
                clientId: r?.clientId,
                fields: r?.fields,
                isDisabled: r?.isDisabled,
            };

        })
                const res = await axios.post('Prequalification/SaveFinancialDataEntry?prequalificationId=' + preq, details)
        if (res?.data?.responseCode == 100) {
            toast.success(res?.data?.data, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setRefresh(!refresh)
          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }


    };

    return (
        <div>
            {SectionType == 11 ? (
                <MainInformation data={FinancialDataEntry} dataChange={dataChange} />
            ) : SectionType == 12 ? (
                <BalanceSheetAssets data={FinancialDataEntry} dataChange={dataChange} />
            ) : SectionType == 13 ? (
                <LiabilitiesandEquity
                    data={FinancialDataEntry}
                    dataChange={dataChange}
                />
            ) : SectionType == 14 ? (
                <IncomeStatement data={FinancialDataEntry} dataChange={dataChange} />
            ) : SectionType == 15 ? (
                <SelectFinancialData
                    dataChange={dataChange}
                    data={FinancialDataEntry}
                />
            ) : (
                <ErrorAlert severity="warning" message="Nothing to show!" />
            )}

            <Box sx={{ flexGrow: 1, marginTop: "20px" }}>
                <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                >
                    <Grid item xs={12} sm={4} md={4}>
                        <Button
                            sx={{ padding: "15px" }}
                            variant="contained"
                            onClick={setPrevSection}
                            label="Previous"
                            hidden={SectionType == "11"}
                        ></Button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                        >
                            <Button variant="contained" label="Save" onClick={Savedata}></Button>
                            <Button
                                variant="contained"
                                onClick={handleClose}
                                label="Cancel"
                            ></Button>
                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <Button
                            sx={{ padding: "15px", float: "right" }}
                            variant="contained"
                            onClick={setNextSection}
                            label="Next"
                            hidden={SectionType == "15"}
                        />
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}